/* Cappafe garage — UK reg lookup → saved vehicle → parts that fit (Euro Car Parts style). */
(function () {
  'use strict';
  var CFG = window.CF_GARAGE || {};
  var root = document.getElementById('cfg');
  if (!root) return;
  var $ = function (id) { return document.getElementById(id); };
  var KEY = 'cfGarage';
  var NOW_YEAR = new Date().getFullYear();

  /* ---------- storage (never throws) ---------- */
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) {} }
  function sget(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {}
    // GA4'e dogrudan: Shopify'in Google kanali window.gtag'i sagliyor, dataLayer'i dinleyen yok.
    try { if (window.gtag) window.gtag('event', name, data || {}); } catch (e) {}
  }

  /* ---------- text helpers ---------- */
  var N = function (s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim(); };
  function titleCase(s) {
    return String(s || '').toLowerCase().replace(/(^|[\s\-\/(])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmtReg(r) {
    r = N(r).replace(/ /g, '');
    if (/^[A-Z]{2}\d{2}[A-Z]{3}$/.test(r)) return r.slice(0, 4) + ' ' + r.slice(4); // current format AB12 CDE
    if (/^[A-Z]\d{1,3}[A-Z]{3}$/.test(r)) return r.replace(/^([A-Z]\d{1,3})/, '$1 ');   // prefix A123 BCD
    return r;
  }

  /* ---------- make mapping (plate make → collection handle) ---------- */
  var MAKE_ALIAS = {
    'VOLKSWAGEN': 'vw', 'VW': 'vw', 'MERCEDES BENZ': 'mercedes', 'MERCEDES': 'mercedes',
    'LAND ROVER': 'land-rover', 'RANGE ROVER': 'land-rover', 'ALFA ROMEO': 'alfa-romeo',
    'SSANGYONG': 'ssangyong', 'SSANG YONG': 'ssangyong', 'OPEL': 'vauxhall', 'BMW MINI': 'mini',
    'CITROEN': 'citroen', 'MAN': 'man'
  };
  function makeOptions() {
    var o = [], sel = $('cfgMake');
    for (var i = 1; i < sel.options.length; i++) o.push({ handle: sel.options[i].value, title: sel.options[i].text });
    return o;
  }
  function makeHandle(make) {
    var m = N(make);
    if (MAKE_ALIAS[m]) return MAKE_ALIAS[m];
    var opts = makeOptions();
    for (var i = 0; i < opts.length; i++) if (N(opts[i].title) === m || N(opts[i].handle) === m) return opts[i].handle;
    for (var j = 0; j < opts.length; j++) if (m.indexOf(N(opts[j].title)) === 0) return opts[j].handle;
    if (MH_MAKE.test(m)) return 'fiat'; // motorhome registered under the converter (Hobby, Bürstner…) — nearly all on a Ducato base
    return null;
  }
  function makeTitle(handle) {
    var opts = makeOptions();
    for (var i = 0; i < opts.length; i++) if (opts[i].handle === handle) return opts[i].title;
    return handle;
  }

  /* ---------- catalogue fit data ---------- */
  function fetchFit(handle) {
    var ck = 'cfgFit:' + handle, cached = sget(ck);
    if (cached) return Promise.resolve(cached);
    var items = [];
    function page(n) {
      return fetch('/collections/' + encodeURIComponent(handle) + '?view=cappafe-vfit&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('fit ' + r.status); return r.json(); })
        .then(function (j) {
          items = items.concat(j.items || []);
          if (j.pages > n && n < 10) return page(n + 1);
          var out = items.map(function (i) { return { model: i[0], years: i[1] ? i[1].split('|') : [], type: i[2] || '', avail: i[3] === 1 }; });
          sset(ck, out);
          return out;
        });
    }
    return page(1);
  }

  function rangeOf(r) {
    var s = String(r).trim(), m;
    if ((m = s.match(/^(\d{4})\s*-\s*(\d{4})$/))) return [+m[1], +m[2]];
    if ((m = s.match(/^(\d{4})\s*(\+|onwards?|on)$/i))) return [+m[1], NOW_YEAR + 1];
    if ((m = s.match(/^(\d{4})$/))) return [+m[1], +m[1]];
    return null;
  }
  function fitsYear(r, y) { var g = rangeOf(r); return !!g && y >= g[0] && y <= g[1]; }

  /* ---------- model matching (plate model text → catalogue model names) ---------- */
  // Catalogue spellings/short names → what a DVLA/DVSA record calls the vehicle.
  var MODEL_ALIAS = {
    'ford|CUSTOM': 'TRANSIT CUSTOM', 'ford|CONNECT': 'TRANSIT CONNECT', 'ford|CONNECT ACTIVE': 'TRANSIT CONNECT ACTIVE',
    'ford|COURIER': 'TRANSIT COURIER', 'ford|EXPORER': 'EXPLORER', 'ford|EXPLOER': 'EXPLORER', 'ford|EXPORER DOUBLE CAB': 'EXPLORER',
    'ford|EXPORER SPORT': 'EXPLORER SPORT', 'ford|MONDEA': 'MONDEO',
    'vw|T4': 'TRANSPORTER', 'vw|T5': 'TRANSPORTER', 'vw|T6': 'TRANSPORTER', 'vw|T6 1': 'TRANSPORTER', 'vw|T7': 'TRANSPORTER',
    'vw|TRANSPORTER CARAVELLE': 'TRANSPORTER', 'vw|T ROCK': 'T ROC', 'vw|SEVERIO 2D': 'SAVEIRO',
    'mercedes|CLASSE V': 'V CLASS', 'mercedes|SPRINTER VOLKSWAGEN CRAFTER': 'SPRINTER', 'mercedes|320': 'ML',
    'mercedes|320 ALL TERAIN': 'E CLASS', 'nissan|ROUGUE': 'ROGUE', 'chrysler|VOYGER': 'VOYAGER',
    'renault|GRAND SCANIC': 'GRAND SCENIC', 'renault|MASTER VAUXHALL MOVANO': 'MASTER', 'renault|MASTER III VAUXHALL MOVANO B': 'MASTER',
    'jaguar|X TAYPE': 'X TYPE', 'ssangyong|KORANTO 3D': 'KORANDO', 'toyota|AVANSSIS': 'AVENSIS', 'toyota|AVANSSIS VERSO': 'AVENSIS VERSO',
    'vauxhall|ASTRA H ESTANSE': 'ASTRA H ESTATE', 'vauxhall|ASTRA J ESTANSE': 'ASTRA J ESTATE', 'volvo|850 CROOS COUNTRY': '850 CROSS COUNTRY',
    'mazda|CX9': 'CX 9', 'jeep|CHEROKEE RENAGEDE': 'CHEROKEE', 'jeep|GRANDCHEROKEE RENAGEDE': 'GRAND CHEROKEE', 'jeep|CHEROKEE KK': 'CHEROKEE',
    'jeep|CHEROKEE KL': 'CHEROKEE', 'jeep|CHEROKEE KJ': 'CHEROKEE', 'jeep|LIBERTY KJ': 'LIBERTY', 'chevrolet|CRUZE HB': 'CRUZE'
  };
  // Tokens that may be missing from a plate record without ruling the model out
  // (generation codes, body styles) — they are ignored after the first token.
  var OPTIONAL = /^([EFG]\d{2}|W\d{3}|MK\d+|MK[IVX]+|I{1,3}|IV|VI?|[A-Z]|K[JKL]|\d{4}|ESTATE|TOURING|AVANT|SW|ST|CW|MCV|SPORTWAGON|SPORTYWAGON|MULTIWAGON|SHUTTLE|AERODECK|ALLROAD|GRAND TOUR|TOUR|HB|5 DOORS|3 DOORS|3D|5D|2D|DOORS|PICK|UP|LIMITED|NOWA)$/;

  // Motorhome converters (as they appear in DVSA model text, incl. common typos) and the base van per make.
  var MOTORHOME = /(^| )(SWIFT|AUTO ?TRAIL|AUTOTRAIL|ADRIA|DETHLEFFS|BAILEY|SUNLIGHT|AUTO ?SLEEPERS?|RAPIDO|RAPDIO|ELDDIS|BURSTNER|HYMER|KNAUS|CHAUSSON|BENIMAR|PILOTE|ROLLER TEAM|LUNAR|MARQUIS|AUTOCRUISE|WILDAX|CARTHAGO|FRANKIA|LAIKA|MCLOUIS|HOBBY|WESTFALIA|BESSACARR|TRIGANO|MOBILVETTA|GIOTTI|KON TIKI|AUTOQUEST|DREAMER|POSSL|SUN LIVING|WEINSBERG|ITINEO)( |$)/;
  var MH_BASE = { fiat: 'DUCATO', ford: 'TRANSIT', peugeot: 'BOXER', citroen: 'JUMPER', mercedes: 'SPRINTER', renault: 'MASTER', vauxhall: 'MOVANO' };
  var MH_MAKE = /^(BURSTNER|HOBBY|HYMER|KNAUS|ADRIA|DETHLEFFS|CHAUSSON|BENIMAR|RAPIDO|SWIFT|AUTO TRAIL|AUTO SLEEPERS|ELDDIS|BAILEY|ROLLER TEAM|CARTHAGO|LAIKA|MCLOUIS|PILOTE|FRANKIA|WEINSBERG|SUNLIGHT)( |$)/;

  // Rebadged twins: when the plate make has nothing for this vehicle, use the sister van's parts.
  function twinOf(handle, pTokens, year) {
    var has = function (t) { return pTokens.indexOf(t) > -1; };
    if (handle === 'man' && has('TGE')) return { handle: 'vw', model: 'CRAFTER' };
    if (handle === 'nissan' && (has('PRIMASTAR') || has('NV300'))) return { handle: 'renault', model: 'TRAFIC' };
    if (handle === 'toyota' && has('PROACE') && !has('CITY')) return { handle: 'peugeot', model: 'EXPERT' };
    if (handle === 'vauxhall' && has('MOVANO')) return year >= 2022 ? { handle: 'fiat', model: 'DUCATO' } : { handle: 'renault', model: 'MASTER' };
    return null;
  }

  function variants(raw) {
    var parts = String(raw).split('/').map(function (p) { return p.trim(); }).filter(Boolean);
    if (parts.length < 2) return [raw];
    var last = parts[parts.length - 1].split(/\s+/), tail = last.slice(1).join(' ');
    return parts.slice(0, -1).map(function (p) { return /\s/.test(p) ? p : (p + ' ' + tail).trim(); }).concat(parts[parts.length - 1]);
  }
  function plateTokens(model, handle) {
    var t = N(model).split(' ').filter(Boolean), out = [];
    var makeN = N(makeTitle(handle)).replace(/ /g, '');
    t.forEach(function (tok) {
      if (makeN && tok.indexOf(makeN) === 0 && tok.length > makeN.length) tok = tok.slice(makeN.length); // MAZDA6 → 6
      out.push(tok);
      var m;
      if (handle === 'bmw' && (m = tok.match(/^(\d)(\d{2})[A-Z]{0,2}$/))) out.push(m[1], 'SERIES');          // 320D → 3 SERIES
      if (handle === 'mercedes' && (m = tok.match(/^([A-Z]{1,3})(\d{2,3})[A-Z]*$/))) out.push(m[1], 'CLASS'); // C220 → C CLASS
    });
    if (handle === 'vw' && out.indexOf('CARAVELLE') > -1) out.push('TRANSPORTER');
    if (handle === 'vw' && out.indexOf('SHUTTLE') > -1) out.push('TRANSPORTER');
    if (handle === 'ford' && out.indexOf('TOURNEO') > -1) out.push('TRANSIT');
    // Electric versions share the van's parts: ETRANSPORTER → TRANSPORTER, EVITO → VITO.
    t.forEach(function (tok) { var m = tok.match(/^E(TRANSPORTER|CRAFTER|VITO|SPRINTER|DUCATO|BOXER|RELAY|JUMPER|DISPATCH|EXPERT|VIVARO|MOVANO|BERLINGO|PARTNER|COMBO|TRANSIT|CADDY)$/); if (m) out.push(m[1]); });
    // "C 220" / "E 300" written with a space → C CLASS / E CLASS.
    if (handle === 'mercedes' && /(^| )[ABCEGSV] \d{2,3}( |$)/.test(N(model))) out.push(N(model).match(/(^| )([ABCEGSV]) \d/)[2], 'CLASS');
    // UK calls the Jumper "Relay"; newer Relays are listed as Jumper in the catalogue.
    if (handle === 'citroen' && out.indexOf('RELAY') > -1) out.push('JUMPER');
    if (handle === 'fiat' && out.indexOf('DICATO') > -1) out.push('DUCATO');
    // Motorhome conversions are registered by converter name; fit parts of the base van.
    if (MH_BASE[handle] && MOTORHOME.test(N(model))) out.push(MH_BASE[handle]);
    return out;
  }
  function scoreModel(catModel, pTokens, handle) {
    var best = 0;
    variants(catModel).forEach(function (v) {
      var key = handle + '|' + N(v);
      var toks = N(MODEL_ALIAS[key] || v).split(' ').filter(Boolean);
      if (!toks.length || pTokens.indexOf(toks[0]) < 0) return;
      var score = 1, ok = true;
      for (var i = 1; i < toks.length; i++) {
        if (pTokens.indexOf(toks[i]) > -1) score++;
        else if (!OPTIONAL.test(toks[i])) { ok = false; break; }
      }
      if (ok && score > best) best = score;
    });
    return best;
  }
  // Best-scoring catalogue models; models with parts for the given year win over those without.
  function matchModels(items, plateModel, handle, year) {
    var pT = plateTokens(plateModel, handle), scores = {}, hasYear = {};
    items.forEach(function (i) {
      if (scores[i.model] == null) scores[i.model] = scoreModel(i.model, pT, handle);
      if (scores[i.model] && (!year || i.years.some(function (r) { return fitsYear(r, year); }))) hasYear[i.model] = 1;
    });
    var pool = Object.keys(hasYear).length ? Object.keys(hasYear) : Object.keys(scores).filter(function (m) { return scores[m] > 0; });
    var max = 0;
    pool.forEach(function (m) { if (scores[m] > max) max = scores[m]; });
    return pool.filter(function (m) { return max && scores[m] === max; });
  }

  // "DUSTER COMFORT TCE" → "Duster": keep plate words that belong to the matched catalogue model(s).
  function cleanModelLabel(plateModel, models, handle) {
    var known = {};
    models.forEach(function (m) {
      variants(m).forEach(function (v) { N(MODEL_ALIAS[handle + '|' + N(v)] || v).split(' ').forEach(function (t) { known[t] = 1; }); });
    });
    var words = String(plateModel).split(/\s+/).filter(function (w) { return known[N(w)]; });
    if (words.length) return titleCase(words.join(' '));
    var w = models.slice().sort(function (x, y) { return x.length - y.length; })[0].split(' ');
    while (w.length > 1 && OPTIONAL.test(N(w[w.length - 1]))) w.pop(); // "C Class C" → "C Class"
    return w.join(' ');
  }

  /* ---------- results for a vehicle ---------- */
  var TYPE_LABEL = {
    'Cross Bar': 'Roof Cross Bars', 'Sets': 'Styling Sets', 'Bonnet Deflectors': 'Bonnet Deflectors',
    'Rear Bumper Sill': 'Rear Bumper Protectors', 'Front Bumper Lip': 'Front Bumper Lips', 'Side Skirt': 'Side Skirts',
    'Spoiler': 'Spoilers', 'Sun Visors': 'Sun Visors', 'Door Sill Protector': 'Door Sill Protectors', 'Fender Flares': 'Fender Flares',
    'Body Cladding Kits': 'Body Cladding Kits', 'Bumper Diffuser': 'Bumper Diffusers', 'Door Cladding': 'Door Cladding',
    'Tailgate': 'Tailgate Trims', 'Wind Deflectors': 'Wind Deflectors', 'Mud Flaps': 'Mud Flaps', 'Wheel Arch Cover': 'Wheel Arch Covers',
    'Mirror Cover': 'Mirror Covers', 'Door Handle': 'Door Handle Covers', 'Bed Rail Protector': 'Bed Rail Protectors', 'Scoop': 'Bonnet Scoops'
  };
  function compute(v, items) {
    var models = v.models || [];
    var fit = items.filter(function (i) {
      return models.indexOf(i.model) > -1 && (!v.year || i.years.some(function (r) { return fitsYear(r, v.year); }));
    });
    var ranges = {}, types = {};
    fit.forEach(function (i) {
      i.years.forEach(function (r) { if (!v.year || fitsYear(r, v.year)) ranges[r] = 1; });
      var t = i.type || 'Other';
      types[t] = types[t] || { type: t, n: 0, avail: 0 };
      types[t].n++; if (i.avail) types[t].avail++;
    });
    return { fit: fit, ranges: Object.keys(ranges), types: Object.keys(types).map(function (k) { return types[k]; }) };
  }
  function partsUrl(v, res, type) {
    var q = [];
    (v.models || []).forEach(function (m) { q.push('filter.p.m.custom.model=' + encodeURIComponent(m)); });
    (res.ranges || []).forEach(function (r) { q.push('filter.p.m.custom.years=' + encodeURIComponent(r)); });
    if (type) q.push('filter.p.product_type=' + encodeURIComponent(type));
    return '/collections/' + v.handle + (q.length ? '?' + q.join('&') : '');
  }

  /* ---------- plate lookup ---------- */
  // Demo plates (only used while no API endpoint is configured).
  var DEMO = {
    TEST1: { make: 'VOLKSWAGEN', model: 'TRANSPORTER T28 HIGHLINE TDI', year: 2017 },
    TEST2: { make: 'FORD', model: 'TRANSIT CUSTOM 290 LIMITED', year: 2020 },
    TEST3: { make: 'DACIA', model: 'DUSTER COMFORT TCE', year: 2019 },
    TEST4: { make: 'BMW', model: '320D M SPORT TOURING', year: 2014 },
    TEST5: { make: 'MERCEDES-BENZ', model: 'C220 AMG LINE D', year: 2016 },
    TEST6: { make: 'VAUXHALL', model: 'VIVARO 2900 SPORTIVE CDTI', year: 2018 }
  };
  function lookup(reg) {
    var r = N(reg).replace(/ /g, '');
    if (!CFG.endpoint) {
      return new Promise(function (res) { setTimeout(function () { res(DEMO[r] ? Object.assign({ ok: true, reg: r, demo: true }, DEMO[r]) : { ok: false, error: 'not_found' }); }, 350); });
    }
    var ctl = window.AbortController ? new AbortController() : null;
    var to = setTimeout(function () { ctl && ctl.abort(); }, 9000);
    return fetch(CFG.endpoint + '?reg=' + encodeURIComponent(r), { signal: ctl ? ctl.signal : undefined })
      .then(function (x) { clearTimeout(to); return x.json(); })
      .catch(function () { clearTimeout(to); return { ok: false, error: 'unavailable' }; })
      .then(function (j) {
        // Worker live but API keys not added yet: keep demo plates working, everything else = unavailable.
        if (j && j.error === 'not_configured') return DEMO[r] ? Object.assign({ ok: true, reg: r, demo: true }, DEMO[r]) : { ok: false, error: 'unavailable' };
        return j;
      });
  }

  /* ---------- UI ---------- */
  function msg(text, isErr) { var m = $('cfgMsg'); m.textContent = text || ''; m.classList.toggle('is-error', !!isErr); }
  function setState(s) { root.setAttribute('data-state', s); }

  function vehLabel(v, sep) {
    var parts = [v.makeLabel || makeTitle(v.handle), v.modelLabel, v.year].filter(Boolean);
    return sep ? parts.join(sep) : parts.join(' ');
  }

  function renderSet(v) {
    setState('set');
    $('cfgRegOut').textContent = v.reg ? fmtReg(v.reg) : '';
    $('cfgMini').hidden = !v.reg;
    $('cfgVeh').textContent = vehLabel(v, ', ');
    $('cfgView').href = v.url || '/collections/' + v.handle;
    $('cfgPopVeh').textContent = titleCase(vehLabel(v, ' ')).replace(/\b(Bmw|Vw|Man|Mg|Gaz)\b/g, function (s) { return s.toUpperCase(); });
    $('cfgViewAll').href = v.url || '/collections/' + v.handle;
  }

  function renderTiles(v, res) {
    var box = $('cfgTiles');
    if (!res.types.length) {
      box.innerHTML = '<p class="cfg-tiles__empty">We don’t have parts listed for this vehicle yet. <a href="/collections/' + esc(v.handle) + '">Browse all ' + esc(makeTitle(v.handle)) + ' parts</a> or <a href="/pages/contact">ask our team</a>.</p>';
      return;
    }
    var t = res.types.slice().sort(function (a, b) { return (b.avail - a.avail) || (b.n - a.n); }).slice(0, 12);
    box.innerHTML = t.map(function (x) {
      var label = TYPE_LABEL[x.type] || x.type;
      return '<a class="cfg-tile" href="' + esc(partsUrl(v, res, x.type)) + '" data-type="' + esc(x.type) + '">' +
        '<span class="cfg-tile__name">' + esc(label) + '</span>' +
        '<span class="cfg-tile__count">' + x.n + (x.n === 1 ? ' part' : ' parts') + '</span></a>';
    }).join('');
  }

  function showPop(show) { $('cfgPop').hidden = !show; }

  // Build the vehicle from a lookup or manual choice, save it and show results.
  function applyVehicle(base, opts) {
    opts = opts || {};
    return fetchFit(base.handle).then(function (items) {
      var v = Object.assign({}, base);
      if (!v.models) v.models = v.plateModel ? matchModels(items, v.plateModel, v.handle, v.year) : [];
      if (v.plateModel && v.models.length && !v.labelFixed) { v.modelLabel = cleanModelLabel(v.plateModel, v.models, v.handle); v.labelFixed = true; }
      var res = compute(v, items);
      // Nothing under the plate make → try the rebadged twin (MAN TGE → VW Crafter …) and show its parts.
      var tw = !res.fit.length && v.plateModel && !v.twinOf && twinOf(v.handle, plateTokens(v.plateModel, v.handle), v.year);
      if (tw) {
        return fetchFit(tw.handle).then(function (titems) {
          var tm = matchModels(titems, tw.model, tw.handle, v.year);
          if (!tm.length) return { v: v, items: items, res: res };
          var tv = Object.assign({}, v, { handle: tw.handle, twinOf: v.handle, models: tm });
          if (!v.labelFixed) tv.modelLabel = titleCase(N(v.plateModel).split(' ')[0]);
          var tres = compute(tv, titems);
          return tres.fit.length ? { v: tv, items: titems, res: tres } : { v: v, items: items, res: res };
        }).catch(function () { return { v: v, items: items, res: res }; });
      }
      return { v: v, items: items, res: res };
    }).then(function (o) {
      var v = o.v, res = o.res;
      v.url = v.models.length ? partsUrl(v, res) : '/collections/' + v.handle;
      v.count = res.fit.length;
      save(v);
      renderSet(v);
      renderTiles(v, res);
      if (CFG.isHome || opts.fresh) showPop(true);
      if (opts.fresh) {
        track('cappafe_vehicle_set', { cf_source: v.source + (v.twinOf ? '-twin' : ''), cf_brand: v.handle, cf_model: (v.models || []).join('|'), cf_year: v.year, cf_results: v.count });
        if (!v.count) track('cappafe_vehicle_no_parts', { cf_brand: v.handle, cf_model: v.modelLabel, cf_year: v.year });
        msg(v.count ? '' : 'We couldn’t find exact-fit parts for this vehicle yet — showing all ' + makeTitle(v.handle) + ' parts.');
      }
      return v;
    });
  }

  function onSubmit(e) {
    e.preventDefault();
    var reg = N($('cfgReg').value).replace(/ /g, '');
    if (reg.length < 2 || reg.length > 8) { msg('Please enter a valid UK registration.', true); $('cfgReg').focus(); return; }
    setState('loading'); msg('Finding your vehicle…');
    track('cappafe_reg_search', {});
    lookup(reg).then(function (r) {
      if (!r || !r.ok) {
        setState('empty');
        track('cappafe_reg_not_found', { reason: r && r.error });
        msg(r && r.error === 'unavailable' ? 'Vehicle lookup is busy right now — please use manual search.' : 'We couldn’t find that registration. Please check it or use manual search.', true);
        openManual(true);
        return;
      }
      var handle = makeHandle(r.make);
      if (!handle) {
        setState('empty');
        track('cappafe_reg_make_unsupported', { make: r.make });
        msg('We don’t stock parts for ' + titleCase(r.make) + ' yet. Please browse our range or contact us.', true);
        return;
      }
      if (!r.model) { // DVLA-only record: make + year known, ask for the model
        setState('empty'); msg('We found a ' + titleCase(r.make) + (r.year ? ' (' + r.year + ')' : '') + ' — please choose your model.');
        openManual(true, { handle: handle, year: r.year, reg: reg });
        return;
      }
      msg(''); openManual(false);
      applyVehicle({
        source: r.demo ? 'demo' : 'reg', reg: reg, handle: handle, makeLabel: titleCase(r.make).replace(/\bBmw\b/, 'BMW').replace(/\bMan\b/, 'MAN').toUpperCase(),
        modelLabel: titleCase(String(r.model).split(' ').slice(0, 2).join(' ')), year: +r.year || null,
        plateModel: (MH_MAKE.test(N(r.make)) ? r.make + ' ' : '') + r.model
      }, { fresh: true }).catch(function () { setState('empty'); msg('Something went wrong. Please try manual search.', true); });
    });
  }

  /* ---------- manual search ---------- */
  var pendingReg = null;
  function openManual(open, pre) {
    var p = $('cfgManual'), btn = $('cfgManualBtn');
    p.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    pendingReg = pre && pre.reg || null;
    if (open && pre && pre.handle) {
      $('cfgMake').value = pre.handle;
      onMake(pre.year);
    }
  }
  function fillSelect(sel, values, placeholder) {
    sel.innerHTML = '<option value="">' + placeholder + '</option>' + values.map(function (v) { return '<option value="' + esc(v) + '">' + esc(v) + '</option>'; }).join('');
    sel.disabled = !values.length;
  }
  function onMake(preYear) {
    var h = $('cfgMake').value, mSel = $('cfgModel'), ySel = $('cfgYear');
    fillSelect(ySel, [], 'Year'); $('cfgFind').disabled = true;
    if (!h) { fillSelect(mSel, [], 'Model'); return; }
    mSel.innerHTML = '<option>Loading…</option>'; mSel.disabled = true;
    fetchFit(h).then(function (items) {
      var models = [], seen = {};
      items.forEach(function (i) { if (!seen[i.model]) { seen[i.model] = 1; models.push(i.model); } });
      models.sort(function (a, b) { return a.localeCompare(b); });
      fillSelect(mSel, models, 'Model');
      mSel._items = items; mSel._preYear = preYear || null;
    }).catch(function () { fillSelect(mSel, [], 'Model'); msg('Could not load models. Please try again.', true); });
  }
  function onModel() {
    var mSel = $('cfgModel'), ySel = $('cfgYear'), m = mSel.value, items = mSel._items || [];
    $('cfgFind').disabled = true;
    if (!m) { fillSelect(ySel, [], 'Year'); return; }
    var lo = 9999, hi = 0;
    items.forEach(function (i) {
      if (i.model !== m) return;
      i.years.forEach(function (r) { var g = rangeOf(r); if (g) { lo = Math.min(lo, g[0]); hi = Math.max(hi, Math.min(g[1], NOW_YEAR)); } });
    });
    var ys = [];
    for (var y = hi; y >= lo && y > 0; y--) ys.push(String(y));
    fillSelect(ySel, ys, 'Year');
    if (mSel._preYear && ys.indexOf(String(mSel._preYear)) > -1) { ySel.value = String(mSel._preYear); }
    $('cfgFind').disabled = !ySel.value && ys.length > 0;
  }
  function onFind() {
    var h = $('cfgMake').value, m = $('cfgModel').value, y = +$('cfgYear').value || null;
    if (!h || !m) return;
    openManual(false); msg('');
    applyVehicle({ source: pendingReg ? 'reg+manual' : 'manual', reg: pendingReg, handle: h, makeLabel: makeTitle(h), modelLabel: m, models: [m], year: y }, { fresh: true });
  }

  function onChange() {
    clear(); showPop(false); msg(''); setState('empty');
    $('cfgReg').value = '';
    try { $('cfgReg').focus({ preventScroll: true }); } catch (e) { $('cfgReg').focus(); }
    track('cappafe_vehicle_change', {});
  }

  /* ---------- animated placeholder (types example regs on the plate) ---------- */
  (function typewriter() {
    var el = $('cfgPh'), input = $('cfgReg');
    if (!el) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var words = ['ENTER YOUR REG', 'AB12 CDE'], wi = 0, ci = words[0].length, del = false, timer = null;
    function idle() { return document.activeElement !== input && !input.value && root.getAttribute('data-state') !== 'set' && !document.hidden; }
    function tick() {
      timer = null;
      if (!idle()) { el.textContent = document.activeElement === input ? 'AB12 CDE' : words[0]; wi = 0; ci = words[0].length; del = false; return schedule(900); }
      var w = words[wi];
      if (!del) {
        if (ci < w.length) { ci++; el.textContent = w.slice(0, ci); return schedule(85 + Math.random() * 60); }
        del = true; return schedule(wi === 0 ? 3200 : 1800);
      }
      if (ci > 0) { ci--; el.textContent = w.slice(0, ci); return schedule(38); }
      del = false; wi = (wi + 1) % words.length; return schedule(320);
    }
    function schedule(ms) { if (!timer) timer = setTimeout(tick, ms); }
    if (reduce) return;
    input.addEventListener('focus', function () { el.textContent = 'AB12 CDE'; });
    input.addEventListener('blur', function () { if (!input.value) { el.textContent = words[0]; wi = 0; ci = words[0].length; del = false; } });
    schedule(2600);
  })();

  /* ---------- wire up ---------- */
  $('cfgForm').addEventListener('submit', onSubmit);
  $('cfgReg').addEventListener('input', function () { var el = this, p = el.selectionStart; el.value = el.value.toUpperCase().replace(/[^A-Z0-9 ]/g, ''); try { el.setSelectionRange(p, p); } catch (e) {} });
  $('cfgManualBtn').addEventListener('click', function () { openManual($('cfgManual').hidden); });
  $('cfgMake').addEventListener('change', function () { onMake(); });
  $('cfgModel').addEventListener('change', onModel);
  $('cfgYear').addEventListener('change', function () { $('cfgFind').disabled = !this.value; });
  $('cfgFind').addEventListener('click', onFind);
  Array.prototype.forEach.call(root.querySelectorAll('[data-cfg-change]'), function (b) { b.addEventListener('click', onChange); });
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.cfg-tile');
    if (a) track('cappafe_vehicle_tile_click', { cf_part_type: a.getAttribute('data-type') });
  });

  CFG._t = { plateTokens: plateTokens, twinOf: twinOf, cleanModelLabel: cleanModelLabel, matchModels: matchModels, compute: compute, partsUrl: partsUrl, makeHandle: makeHandle };

  // Restore a saved vehicle (refresh data in the background so stock/counts stay current).
  var saved = load();
  if (saved && saved.handle) {
    renderSet(saved);
    applyVehicle(saved).catch(function () {});
  } else {
    setState('empty');
  }
})();
